import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {EMPLOYEE_AREA_NAME} from "../users/Employee";



export const EmployerModule: Module = {
    identifier: "employers",
    isPrivileged: ( authUser, privilege) => isPrivileged(
        authUser,
        EMPLOYEE_AREA_NAME,
        EmployerModule.identifier,
        privilege
    )
}